import { Box, Button, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { SignIn } from "../../../../../api/Summary";
import { AlertSuccess } from "../../../../../component/basic/feedbacks/snackbar/Snackbar";
import { CardBox } from "../../../../../component/basic/surfaces/box/CardBox";
import { BuySVIPButton } from "../../../../../component/business/dialog/component/BuySVIPButton";
import { BuyVIPButton } from "../../../../../component/business/dialog/component/BuyVIPButton";
import { RoleKind } from "../../../../../model/Role";
import { UserDaily } from "../../../../../model/statistic/Daily";
import { useAppDispatch } from "../../../../../store/hooks";
import { actionSetCalendarDays, actionSetDaily } from "../../../../../store/root/reducer";
import { selectDaily } from "../../../../../store/root/selector";
import { selectUser } from "../../../../../store/user/selector";
import { Colors } from "../../../../../tools/color";
import { NoticeContent } from "./NoticeContent";

interface NoticeBoardProps {}
export function NoticeBoard(props: NoticeBoardProps) {
    return (
        <CardBox
            sx={{
                width: "50%",
                margin: "10px",
                display: "flex",
                alignItems: "center",
                position: "relative",
            }}
        >
            <NoticeTitle />
            <NoticeContent />
            <SignInBox />
            <VIPButtons />
        </CardBox>
    );
}

// 公告栏标题+红色小圆点
function NoticeTitle() {
    return (
        <>
            <Box
                sx={{
                    position: "absolute",
                    left: "10px",
                    top: "10px",
                    height: "35px",
                    width: "35px",
                    borderRadius: "50%",
                    background: Colors["primarya"],
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    left: "20px",
                    top: "20px",
                    fontSize: "1.2rem",
                }}
            >
                <b>公告栏</b>
            </Box>
        </>
    );
}

function VIPButtons() {
    const user = useSelector(selectUser);

    return (
        <Stack
            direction="row"
            sx={{ position: "absolute", right: "0", top: "15px", alignItems: "end" }}
        >
            {user.authority.role_kind < RoleKind.VIP && (
                <Box sx={{ mr: "15px" }}>
                    <BuyVIPButton size="small" />
                </Box>
            )}
            {user.authority.role_kind < RoleKind.SVIP && (
                <Box sx={{ mr: "15px" }}>
                    <BuySVIPButton size="small" />
                </Box>
            )}
        </Stack>
    );
}

function SignInBox() {
    const dispatch = useAppDispatch();

    const daily = useSelector(selectDaily);

    return (
        <Box sx={{ position: "absolute", right: "20px", bottom: "20px" }}>
            <Button
                color="info"
                onClick={() => {
                    SignIn({
                        afterSuccess: (d: UserDaily, days: number[]) => {
                            dispatch(actionSetDaily(d));
                            dispatch(actionSetCalendarDays(days));
                            AlertSuccess("打卡成功");
                        },
                        dispatch,
                    });
                }}
                disabled={daily.signed}
            >
                打卡签到
            </Button>
        </Box>
    );
}
